// Static fallback data for resort areas
// This is used when the API is unavailable

export const RESORT_MAP_URL = "/resort-map.png?v=13";

export const HOTEL_PLAN_URL = "/hotel-plan.png?v=14";

export const FLOOR_PLAN_EXTENDED_URL = "/floor-plan-extended.png?v=19";

export const BACK_OF_HOUSE_URL = "/back-of-house.png?v=16";

export const FALLBACK_AREAS = [
  {
    id: "beach",
    name: "Beach",
    zone: "outdoor",
    description: "The pristine beachfront has been fully restored with new sand replenishment, reinforced seawalls, and enhanced cabana structures to withstand future storms.",
    status: "completed",
    before_image: "https://images.unsplash.com/photo-1544348762-563b21915893?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxodXJyaWNhbmUlMjBkYW1hZ2UlMjByZXNvcnQlMjBidWlsZGluZ3xlbnwwfHx8fDE3NzYxMTMzOTV8MA&ixlib=rb-4.1.0&q=85",
    after_image: "https://images.unsplash.com/photo-1673964566152-2aee6bc89929?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxyZXNvcnQlMjBiZWFjaCUyMHJlc3RhdXJhbnQlMjB0cm9waWNhbHxlbnwwfHx8fDE3NzYxMTMzOTV8MA&ixlib=rb-4.1.0&q=85",
    enhancements: [
      { title: "Storm-Resistant Seawall", description: "New reinforced seawall designed to Category 5 standards" },
      { title: "Sand Replenishment", description: "Over 15,000 tons of premium white sand imported and graded" },
      { title: "Beach Cabanas", description: "12 new hurricane-rated luxury cabanas with retractable canopies" }
    ],
    position_x: 15,
    position_y: 5
  },
  {
    id: "sugar-mill-falls",
    name: "Sugar Mill Falls",
    zone: "outdoor",
    description: "The signature Sugar Mill Falls water feature has been completely rebuilt with improved rock formations, upgraded pump systems, and new LED lighting.",
    status: "completed",
    before_image: "https://images.unsplash.com/photo-1613416067466-4c0648a8f0f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxodXJyaWNhbmUlMjBkYW1hZ2UlMjByZXNvcnQlMjBidWlsZGluZ3xlbnwwfHx8fDE3NzYxMTMzOTV8MA&ixlib=rb-4.1.0&q=85",
    after_image: "https://images.unsplash.com/photo-1713748943315-e30cb4ee15ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB0cm9waWNhbCUyMHJlc29ydCUyMHBvb2wlMjByZW5vdmF0aW9ufGVufDB8fHx8MTc3NjExMzM5NXww&ixlib=rb-4.1.0&q=85",
    enhancements: [
      { title: "Rock Formations", description: "Hand-placed natural stone with embedded drainage systems" },
      { title: "LED Lighting", description: "Color-changing underwater LEDs for evening ambiance" },
      { title: "Pump Upgrade", description: "New energy-efficient circulation system with 40% less power consumption" }
    ],
    position_x: 35,
    position_y: 35
  }
];

